module.exports = __webpack_public_path__ + "img/plane.bae5b39f.svg";